import React from 'react';
import './scss/print-setting.styles.scss'
import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { PrintModuleAuxiliaryModeContext } from './print-module-auxiliary-mode-context';
import RadioButtonsGroup from '../../component/radio/radio.component';
import CheckBoxGroup from '../../component/checkbox/checkbox.component';
import _ from 'lodash';
import { IOSSwitch } from '../../component/switch/IOSSwitch';
import { apiManage_rbp as apiManage } from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import i18n from '../../i18n';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import CommonInput from '../../component/form/common-input.component';
import BASE_CHECK_TYPE from '../../constants/regular.constant';
import axios from 'axios';

function PrintSettingRowHeading(props: { title: string; subtitle?: string }) {
    const { auxiliaryModeEnabled } = React.useContext(PrintModuleAuxiliaryModeContext);
    return (
        <Box className='print-setting-row__text'>
            <Typography component='div' className='print-setting-row__title'>{props.title}</Typography>
            {auxiliaryModeEnabled && props.subtitle ? (
                <Typography component='div' className='print-setting-row__subtitle'>{props.subtitle}</Typography>
            ) : null}
        </Box>
    );
}

function PrintSettingToggleRow(props: { title: string; subtitle?: string; control: React.ReactNode }) {
    return (
        <Box className='print-setting-row print-setting-row--toggle'>
            <PrintSettingRowHeading title={props.title} subtitle={props.subtitle} />
            <Box className='print-setting-row__control'>{props.control}</Box>
        </Box>
    );
}

function PrintSettingSwitchBlock(props: {
    title: string;
    subtitle?: string;
    checked: boolean;
    onToggle: () => void;
    children?: React.ReactNode;
}) {
    return (
        <Box className='print-setting-subsection'>
            <PrintSettingToggleRow
                title={props.title}
                subtitle={props.subtitle}
                control={(
                    <IOSSwitch
                        checked={props.checked}
                        onChange={() => { props.onToggle(); }}
                    />
                )}
            />
            {props.children ? (
                <Box className='print-setting-subsection__content'>
                    <Box className='print-setting-checkbox-wrap'>{props.children}</Box>
                </Box>
            ) : null}
        </Box>
    );
}

function PrintSettingRadioBlock(props: { title: string; subtitle?: string; children: React.ReactNode }) {
    return (
        <Box className='print-setting-subsection'>
            <PrintSettingRowHeading title={props.title} subtitle={props.subtitle} />
            <Box className='print-setting-subsection__content'>
                <Box className='print-setting-radio-wrap'>{props.children}</Box>
            </Box>
        </Box>
    );
}

// const STATUS_STYLE_TEXT = {
//     1: {
//         style: {
//             color: 'rgb(0, 200, 83)',
//             backgroundColor: 'rgba(185, 246, 202, 0.376)'
//         },
//         text: 'Online'
//     },
//     0: {
//         style: {
//             color: 'rgb(216, 67, 21)',
//             backgroundColor: 'rgb(251, 233, 231)'
//         },
//         text: 'Offline'
//     }
// }
class PrintSettingPage extends React.Component<Props, State> {
    private persistSwParamDebounced!: () => void;
    private notifyPersistSuccess!: () => void;
    /** 开关/多选快速连点时合并为一次落库（对应 rule 30 / 34 / 181 / 166） */
    private persistRule30Debounced!: () => void;
    private persistRule34Debounced!: () => void;
    private persistRule181Debounced!: () => void;
    private persistRule166Debounced!: () => void;

    private static readonly PATCH_SWITCH_DEBOUNCE_MS = 800;

    constructor(props: Props) {
        super(props);

        this.persistSwParamDebounced = _.debounce(
            () => { void this.patchSwParamFromState(); },
            600,
            { leading: false, trailing: true }
        ) as any;
        this.notifyPersistSuccess = _.debounce(
            () => {
                GlobalNotification.success(i18n.t('global_text_update_success'));
            },
            400,
            { leading: false, trailing: true }
        ) as any;
        const switchDebounce = PrintSettingPage.PATCH_SWITCH_DEBOUNCE_MS;
        this.persistRule30Debounced = _.debounce(
            () => { void this.patchRule30FromState(); },
            switchDebounce,
            { leading: false, trailing: true }
        ) as any;
        this.persistRule34Debounced = _.debounce(
            () => { void this.patchRule34FromState(); },
            switchDebounce,
            { leading: false, trailing: true }
        ) as any;
        this.persistRule181Debounced = _.debounce(
            () => { void this.patchRule181FromState(); },
            switchDebounce,
            { leading: false, trailing: true }
        ) as any;
        this.persistRule166Debounced = _.debounce(
            () => { void this.patchRule166FromState(); },
            switchDebounce,
            { leading: false, trailing: true }
        ) as any;
    }

    // 打印类型
    private printType = {
        sendorder: 'print_basic_setting_page_rbp_sendorder_tip',
        takeaway: 'print_basic_setting_page_rbp_takeaway_tip',
        returnDishes: 'print_basic_setting_page_rbp_returnDishes_tip',
        payment: 'print_basic_setting_page_rbp_payment_tip'
    }

    projectList = [{ label: 'CWA', value: 'CWA' }, { label: 'RWA', value: 'RWA' }];

    projectListPush = [{ label: 'CWA', value: 'CWA' }, { label: 'RWA', value: 'RWA' }, { label: 'KWA', value: 'KWA' }];

    /** 云 Shell 无 RBP Redux 的 apiVersion，默认展示 SW 相关参数（与新版 RBP 行为一致） */
    showSwParam = true;

    defaultPrintName = { 0: 'Eat in', 1: 'Take away', 2: 'Delivery', 3: 'Pick up' };

    public state: State = {
        printQueueData: [],
        // 选择的队列
        selectedPrintQueue: [],
        //被选中的一菜一单打印机
        checkList: [],
        // 被选中的 送厨单打印字体大小的值
        selectFontSizeValue: 0,
        //是否分单打印
        isHouseBillOfLadingPrinters: false,
        // 送厨单头部空行
        selectEmptyLineValue: 0,
        // 送厨单打印菜品名方式
        selectPrintDishNameType: 0,
        // 送厨单Name1和Name2只显示一行
        deliveryListName1AndName2ShowOnlyOneLine: 0,
        // RWA2 控制是否 打印外卖总单的 打印机
        rwa2PrintTakeAwayCheckkList: [],
        // RWA2 控制是否 开关
        printTakeAwayCheck: false,
        // CWA2 控制是否 打印外卖总单的 打印机
        cwa2PrintTakeAwayCheckkList: [],
        // CWA2 控制是否开关
        cwa2PrintTakeAwayCheck: false,
        // 是否开启打印心跳机制时间
        isHeartbeatMechanism: false,
        // 打印心跳机制时间
        heartbeatMechanism: 0,
        // 原始打印心跳机制时间
        originHeartbeatMechanism: 0,
        // 是否打印预结单
        isPrintAdvanceStatement: false,
        // 是否开启转台打印
        tableTransferPrinting: {
            enable: false,
            printers: []
        },
        // 是否打印免费菜品
        isPrintFreeDishes: false,
        // 打印预结单的 打印机
        isPrintAdvanceStatementPrinters: [],
        // 是否开启 RWA 首次下单打印总单
        isPrintFirstOrderSummary: false,
        // RWA 首次下单打印总单的打印机
        isPrintFirstOrderSummaryPrinters: [],
        // 打印模式
        printMode: 0,
        // 所有打印机
        allPrinter: [],
        // 打印型号
        printerType: 'EPSON',
        // 打印端口
        printerInterface: 'tcp',
        // 打印端口号
        printerPort: '9100',
        // 测试打印机
        checkedLocationList: [],
        // 删除确认框
        alertDialogOpen: false,
        // SW打印参数
        swParam: {
            ip: '',
        },
        // 送厨单是否打印轮次
        sendifPrint: true,
        // 是否开启退菜打印
        isPrintReturns: true,
        selectedProject: ['RWA', 'CWA'],
        // 是否开启催菜打印
        isPrintPush: false,
        pushSelectedProject: ['CWA', 'RWA', 'KWA'],
        // 送厨单打印排序
        sendPrintSort: 0,
        // 打印外卖TA后缀
        isPrintTakeAway: true,
        // 打印套餐SET后缀
        isPrintSet: true,
        // 外卖总单打印排序
        printTakeAwaySort: 0,
        // 预结单打印排序
        prePrintSort: 0,
        // 订单类型打印名称
        orderTypePrintName: this.defaultPrintName,
        // ws打印机状态
        wsPrinterStatus: -1,
        pageLoading: true,
    }

    // *********************
    // Life Cycle Function
    // *********************
    componentDidMount() {
        this.init()
    }

    componentWillUnmount() {
        (this.persistSwParamDebounced as any)?.cancel?.();
        (this.notifyPersistSuccess as any)?.cancel?.();
        (this.persistRule30Debounced as any)?.cancel?.();
        (this.persistRule34Debounced as any)?.cancel?.();
        (this.persistRule181Debounced as any)?.cancel?.();
        (this.persistRule166Debounced as any)?.cancel?.();
    }

    // *********************
    // Default Function
    // *********************
    /**
     * 获取
     */
    async init() {
        try {
            await Promise.all([
                this.getprinter(),
                this.getPrintQueue(),
                this.getSetting(),
            ]);
        } finally {
            this.setState({ pageLoading: false });
        }
    }

    /**
     * 获取设置
     */
    async getSetting() {
        const allSetting = await apiManage.getSetting();
        // $ 一菜一单打印机 rule-one-dish-one-order: 12
        // const ruleOneDishOneOrder = this.getSettingValue(allSetting, 12);
        // const checkList = ruleOneDishOneOrder?.printer?.map((item: printdevice) => {
        //     return `${item.print_device_id + '、' + item.print_device_name}`
        // }) || [];
        // $ 送厨单打印字体大小设置 rule-printer-font-size: 11
        const selectFontSizeValue = this.getSettingValue(allSetting, 11)?.quantity;
        // $ 自主点菜分单打印 13
        const isHouseBillOfLadingPrinters = this.getSettingValue(allSetting, 13)?.status;
        // $ 获取送厨单头部空行 24
        const selectEmptyLineValue = this.getSettingValue(allSetting, 24);
        // $ 获取需要显示的极速点餐精确搜索规则 25
        const selectPrintDishNameType = this.getSettingValue(allSetting, 25);
        // $ 送厨单Name1和Name2只显示一行 28
        const deliveryListName1AndName2ShowOnlyOneLine = this.getSettingValue(allSetting, 28)?.line;
        // $ RWA2 打印外卖总单 rwa2-take-away-check-print 30
        const rwa2takeAwayCheckPrint = this.getSettingValue(allSetting, 30);
        const rwa2PrintTakeAwayCheckkList = rwa2takeAwayCheckPrint?.printer?.map((item: printdevice) => {
            return `${item.print_device_id + '、' + item.print_device_name + '、' + item.printer_name}`
        }) || [];
        const printTakeAwayCheck = !!rwa2takeAwayCheckPrint?.enable;
        // $ CWA2控制是否 打印外卖总单 rwa2-take-away-check-print 31
        // const caw2takeAwayCheckPrint = this.getSettingValue(allSetting, 31);
        // const cwa2PrintTakeAwayCheckkList = caw2takeAwayCheckPrint?.printer?.map((item: printdevice) => {
        //     return `${item.print_device_id + '、' + item.print_device_name + '、' + item.printer_name}`
        // }) || [];
        // const cwa2PrintTakeAwayCheck = !!caw2takeAwayCheckPrint?.enable;
        // $ 打印服务心跳时间间隔 print-heartbeats-times 32
        const printHeartbeatsTimes = this.getSettingValue(allSetting, 32);
        const isHeartbeatMechanism = printHeartbeatsTimes?.enable;
        const heartbeatMechanism = printHeartbeatsTimes?.mins;
        const originHeartbeatMechanism = printHeartbeatsTimes?.mins;

        // $ 获取打印预结单 payment-check-print 34
        const paymentCheckPrint = this.getSettingValue(allSetting, 34);
        const isPrintAdvanceStatement = !!paymentCheckPrint?.enable;
        const isPrintFreeDishes = !!paymentCheckPrint?.showCondiment;
        const isPrintAdvanceStatementPrinters = paymentCheckPrint?.printer?.map((item: { print_device_id: string, print_device_name: string, printer_name: string }) => {
            return `${item.print_device_id + '、' + item.print_device_name + '、' + item.printer_name}`
        }) || [];
        // $ 获取 RWA 首次下单打印总单 181
        const firstOrderSummaryPrint = this.getSettingValue(allSetting, 181);
        const isPrintFirstOrderSummary = !!firstOrderSummaryPrint?.enable;
        const isPrintFirstOrderSummaryPrinters = firstOrderSummaryPrint?.printer?.map((item: { print_device_id: string, print_device_name: string, printer_name: string }) => {
            return `${item.print_device_id + '、' + item.print_device_name + '、' + item.printer_name}`
        }) || [];
        // $  获取需要显示的极速点餐精确搜索规则 40
        const printMode = this.getSettingValue(allSetting, 40);

        // $  获取SW打印机的设置 112
        const SwRes = this.getSettingValue(allSetting, 112);
        const swParam = { ip: SwRes?.ip || '', port: SwRes?.port }

        // $  获取送厨单是否打印轮次的设置 116
        const sendRes = this.getSettingValue(allSetting, 116);
        const sendParam = !sendRes;
        // $  退菜打印
        const returnPrint = this.getSettingValue(allSetting, 122);
        // $  催菜打印
        const printPush = this.getSettingValue(allSetting, 144);
        //  $  获取送厨单打印排序
        const sendPrintSort = this.getSettingValue(allSetting, 126) || 0;
        // 外卖总单打印排序
        const printTakeAwaySort = this.getSettingValue(allSetting, 165) || 0;
        // 预结单打印排序
        const prePrintSort = this.getSettingValue(allSetting, 176) || 0;
        // 打印外卖TA后缀 打印套餐SET后缀 164
        const { isPrintTakeAway, isPrintSet } = this.getPrintSetting(allSetting);
        // 是否开启转台打印
        const setting166 = this.getSettingValue(allSetting, 166) || {
            enable: false,
            printers: []
        };
        const tableTransferPrinting = {
            enable: setting166.enable,
            printers: (setting166.printers || []).map((item: { print_device_id: string, print_device_name: string, printer_name: string }) => {
                return `${item.print_device_id + '、' + item.print_device_name + '、' + item.printer_name}`
            }),
        };
        // 订单类型打印名称
        let orderTypePrintName = _.cloneDeep(this.defaultPrintName);
        const setting175: any = this.getSettingValue(allSetting, 175);
        setting175 && (orderTypePrintName = setting175)
        await new Promise<void>((resolve) => {
            this.setState({
                //被选中的一菜一单打印机
                // checkList,
                // 被选中的 送厨单打印字体大小的值
                selectFontSizeValue,
                //是否分单打印
                isHouseBillOfLadingPrinters,
                // 送厨单头部空行
                selectEmptyLineValue,
                // 送厨单打印菜品名方式
                selectPrintDishNameType,
                // 送厨单Name1和Name2只显示一行
                deliveryListName1AndName2ShowOnlyOneLine,
                // RWA2 控制是否 打印外卖总单的 打印机
                rwa2PrintTakeAwayCheckkList,
                // RWA2 控制是否开关
                printTakeAwayCheck,
                // // CWA2 控制是否 打印外卖总单的 打印机
                // cwa2PrintTakeAwayCheck,
                // // CWA2 控制是否开关
                // cwa2PrintTakeAwayCheckkList,
                // 是否开启打印心跳机制时间
                isHeartbeatMechanism,
                // 打印心跳机制时间
                heartbeatMechanism,
                // 原始打印心跳机制时间
                originHeartbeatMechanism,
                // 是否打印预结单
                isPrintAdvanceStatement,
                // 是否开启转台打印
                tableTransferPrinting,
                // 是否打印免费菜品
                isPrintFreeDishes,
                // 打印预结单的 打印机
                isPrintAdvanceStatementPrinters,
                // 是否开启 RWA 首次下单打印总单
                isPrintFirstOrderSummary,
                // RWA 首次下单打印总单的打印机
                isPrintFirstOrderSummaryPrinters,
                // 打印模式
                printMode,
                // SW打印机参数
                swParam,
                // 送厨单是否打印
                sendifPrint: sendParam,
                // 退菜打印
                isPrintReturns: _.get(returnPrint, 'enable') ?? true,
                selectedProject: _.get(returnPrint, 'project') ?? ['CWA', 'RWA'],
                // 催菜打印
                isPrintPush: _.get(printPush, 'enable') ?? false,
                pushSelectedProject: _.get(printPush, 'project') ?? ['CWA', 'RWA', 'KWA'],
                sendPrintSort,
                // 打印外卖TA后缀
                isPrintTakeAway,
                // 打印套餐SET后缀
                isPrintSet,
                // 外卖总单打印排序
                printTakeAwaySort,
                // 预结单打印排序
                prePrintSort,
                // 订单类型打印名称
                orderTypePrintName,
            }, () => {
                // 云端不需要获取ws打印机状态
                // this.getWsPrinterStatus();
                resolve();
            });
        });
    }

    /**
     * 获取设置中的值
     */
    getSettingValue(allSetting: any[], id: number) {
        return _.find(allSetting, (n) => { return n?.id === id })?.value;
    }

    /**
     * 获取打印设置 默认是true
     * id 164   value  [{ "id": 1, "name": "ta", "value": 1 }, { "id": 2, "name": "set", "value": 1 }]
     * @param allSetting 
     */
    getPrintSetting(allSetting: any[]) {
        const printSetting = this.getSettingValue(allSetting, 164);
        // 判断printSetting存在并且是数组
        if (printSetting) {
            const isPrintTakeAway = _.get(printSetting, '0.value') !== 0
            const isPrintSet = _.get(printSetting, '1.value') !== 0
            return {
                isPrintTakeAway,
                isPrintSet
            }
        }
        return {
            isPrintTakeAway: true,
            isPrintSet: true
        }
    }

    /**
     * 获取所有打印机
     */
    async getprinter() {
        const res = await apiManage.getPrintersDevice();
        if (!res?.error) {
            this.setState({
                allPrinter: res
            })
        }
    }

    /**
     * 获取所有打印队列
     */
    async getPrintQueue() {
        const res = await apiManage.getPrintersQueue();
        if (!res?.error) {
            this.setState({
                printQueueData: res || [],
                selectedPrintQueue: []
            })
        }
    }

    /**
     * 删除付款队列数据
     * @returns
     */
    async deletePrintQueueData() {
        const printId = this.state.selectedPrintQueue.map((data: any) => data.id);
        const res = await apiManage.delPrintersQueue(printId);
        if (!res?.error) {
            GlobalNotification.success(i18n.t('google_text_delete_success'));
        } else {
            GlobalNotification.error(i18n.t('google_text_delete_failed'));
        }
        this.setState({ selectedPrintQueue: [] });
    }
    /**
     * 测试打印
     */
    testPrinter() {
        const { checkedLocationList, printerType, printerInterface, printerPort, printMode, allPrinter } = this.state;
        if (checkedLocationList.length > 0) {
            checkedLocationList.forEach(async (item) => {
                const printDeviceId = item?.split('、')?.[0];
                const printDevice = _.find(allPrinter, (n) => { return n.print_device_id === Number(printDeviceId) });
                if (printDevice) {
                    const data = {
                        type: printerType,
                        theinterface: `${printerInterface}://${printDevice.printer_name}:${printerPort}`,
                        printMode: printMode
                    }
                    const res = await apiManage.postPrintersTest(data);
                    if (res?.error) {
                        GlobalNotification.error(res?.result?.message || data.theinterface)
                    }
                }
            })
        }
    }
    /**
     * 过滤已选择的打印机
     */
    rebulidPrinterData(selectedData: string[]) {
        let allPrinter = _.cloneDeep(this.state.allPrinter);
        selectedData = selectedData.map((item) => item?.split('、')?.[0])
        allPrinter = allPrinter.filter((item) => {
            return selectedData.includes(`${item.print_device_id}`);
        })
        return allPrinter;
    }


    /** 订单类型名称须全部非空（与原先整页保存校验一致），否则不允许其它项落库 */
    private validateOrderTypeNamesOrToast(): boolean {
        const { orderTypePrintName } = this.state;
        const ok = Object.values(orderTypePrintName).every((v) => v && String(v)?.trim());
        if (!ok) {
            GlobalNotification.error(
                `${i18n.t('print_basic_setting_page_order_type_print_name')}：${i18n.t('dis_setting_page_type_entire_info')}`
            );
            return false;
        }
        return true;
    }

    private validateSwOrToast(): boolean {
        const { printMode, swParam } = this.state;
        if (![3, 4].includes(printMode)) {
            return true;
        }
        const regular = BASE_CHECK_TYPE['ip']?.regular;
        if (!regular?.test(String(swParam.ip)) || typeof swParam.port !== 'number') {
            GlobalNotification.error(i18n.t('cash_drop_page_enter_the_correct_IP_address'));
            return false;
        }
        return true;
    }

    /** 按顺序执行多个 patch，全部成功后再统一成功提示并拉取设置 */
    private async execPatchesThenRefresh(patches: Array<() => Promise<{ error?: boolean }>>): Promise<void> {
        if (!this.validateOrderTypeNamesOrToast()) {
            return;
        }
        try {
            for (const run of patches) {
                const res = await run();
                if (res?.error) {
                    GlobalNotification.error(i18n.t('global_text_update_failure'));
                    return;
                }
            }
            this.notifyPersistSuccess();
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_update_failure'));
            await this.getSetting();
            console.log(error);
        }
    }

    private async patchPrintModeFromState() {
        const { printMode, swParam } = this.state;
        if ([3, 4].includes(printMode) && !this.validateSwOrToast()) {
            return;
        }
        const runners: Array<() => Promise<{ error?: boolean }>> = [
            () => apiManage.patchSettingById(40, { stringValue: printMode }),
        ];
        if ([3, 4].includes(printMode)) {
            runners.push(() =>
                apiManage.patchSettingById(112, {
                    ip: swParam.ip,
                    port: swParam.port,
                })
            );
        }
        await this.execPatchesThenRefresh(runners);
    }

    private async patchSwParamFromState() {
        if (![3, 4].includes(this.state.printMode)) {
            return;
        }
        if (!this.validateSwOrToast()) {
            return;
        }
        const { swParam } = this.state;
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(112, { ip: swParam.ip, port: swParam.port }),
        ]);
    }

    private async patchRule13FromState() {
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(13, { status: this.state.isHouseBillOfLadingPrinters }),
        ]);
    }

    private async patchRule30FromState() {
        const { printTakeAwayCheck, rwa2PrintTakeAwayCheckkList } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingById(30, {
                    enable: printTakeAwayCheck,
                    printer: this.rebulidPrinterData(rwa2PrintTakeAwayCheckkList),
                }),
        ]);
    }

    private async patchRule34FromState() {
        const { isPrintAdvanceStatement, isPrintFreeDishes, isPrintAdvanceStatementPrinters } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingById(34, {
                    enable: isPrintAdvanceStatement,
                    showCondiment: isPrintFreeDishes,
                    printer: this.rebulidPrinterData(isPrintAdvanceStatementPrinters),
                }),
        ]);
    }

    private async patchRule181FromState() {
        const { isPrintFirstOrderSummary, isPrintFirstOrderSummaryPrinters } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingById(181, {
                    enable: isPrintFirstOrderSummary,
                    printer: this.rebulidPrinterData(isPrintFirstOrderSummaryPrinters),
                }),
        ]);
    }

    private async patchRule166FromState() {
        const { tableTransferPrinting } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingById(166, {
                    enable: tableTransferPrinting.enable,
                    printer: this.rebulidPrinterData(tableTransferPrinting.printers || []),
                }),
        ]);
    }

    private async patchRule116FromState() {
        const { sendifPrint } = this.state;
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(116, { stringValue: Number(!sendifPrint) }),
        ]);
    }

    private async patchRule25FromState() {
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(25, { stringValue: Number(this.state.selectPrintDishNameType) }),
        ]);
    }

    private async patchRule126FromState() {
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(126, { stringValue: this.state.sendPrintSort }),
        ]);
    }

    private async patchRule122FromState() {
        const { isPrintReturns, selectedProject } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingById(122, {
                    stringValue: JSON.stringify({
                        enable: isPrintReturns,
                        project: selectedProject,
                    }),
                }),
        ]);
    }

    private async patchRule144FromState() {
        const { isPrintPush, pushSelectedProject } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingById(144, {
                    stringValue: JSON.stringify({
                        enable: isPrintPush,
                        project: pushSelectedProject,
                    }),
                }),
        ]);
    }

    private async patchRule176FromState() {
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(176, { stringValue: this.state.prePrintSort }),
        ]);
    }

    private async patchRule165FromState() {
        await this.execPatchesThenRefresh([
            () => apiManage.patchSettingById(165, { stringValue: this.state.printTakeAwaySort }),
        ]);
    }

    private async patchRule164FromState() {
        const { isPrintTakeAway, isPrintSet } = this.state;
        await this.execPatchesThenRefresh([
            () =>
                apiManage.patchSettingByIdByArr(164, [
                    { id: 1, name: 'ta', value: isPrintTakeAway ? 1 : 0 },
                    { id: 2, name: 'set', value: isPrintSet ? 1 : 0 },
                ]),
        ]);
    }

    private async patchOrderTypeNamesFromState() {
        if (!this.validateOrderTypeNamesOrToast()) {
            return;
        }
        try {
            const res = await apiManage.patchSettingById(175, {
                stringValue: JSON.stringify(this.state.orderTypePrintName),
            });
            if (res?.error) {
                GlobalNotification.error(i18n.t('global_text_update_failure'));
                return;
            }
            this.notifyPersistSuccess();
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_update_failure'));
            await this.getSetting();
            console.log(error);
        }
    }

    /**
     * 订单类型翻译
     */
    getOrderTypeName = (type: number) => {
        const obj: { [key: number]: string } = {
            0: i18n.t('google_text_eat_in'),
            1: i18n.t('google_text_take_away'),
            2: i18n.t('google_text_orderdelivery'),
            3: i18n.t('google_text_pick_up'),
        }
        return obj?.[type] || ''
    }

    /**
     * 获取ws打印机状态
     */
    getWsPrinterStatus = async () => {
        try {
            this.setState({
                wsPrinterStatus: -1
            })
            const { swParam, printMode } = this.state;
            if (![3, 4].includes(printMode)) {
                this.setState({
                    wsPrinterStatus: 0
                })
                return;
            }
            const res = await axios.get(`http://${swParam.ip}:${swParam.port}/Index/Status`, { timeout: 2000 });
            this.setState({
                wsPrinterStatus: res?.status === 200 ? 1 : 0
            })
        } catch (e: any) {
            console.log('获取ws打印机状态error', e)
            this.setState({
                wsPrinterStatus: 0,
            })
            GlobalNotification.error(`${i18n.t('print_basic_setting_page_printer_connection_failed')}: ${e?.message}`);
        }
    }

    /**
     * 跳转网站
     */
    goWebSite = () => {
        const { swParam, wsPrinterStatus } = this.state;
        wsPrinterStatus === 1 && window.open(`http://${swParam.ip}:${swParam.port}/swagger `, '_blank');
    }

    // *********************
    // View
    // *********************

    render() {
        if (this.state.pageLoading) {
            return <PrintSettingPageSkeleton />;
        }
        const {
            printMode, alertDialogOpen,
            isHouseBillOfLadingPrinters, printTakeAwayCheck, rwa2PrintTakeAwayCheckkList,
            isPrintAdvanceStatement, tableTransferPrinting, isPrintAdvanceStatementPrinters, isPrintFreeDishes,
            isPrintFirstOrderSummary, isPrintFirstOrderSummaryPrinters,
            selectPrintDishNameType, swParam, sendifPrint, isPrintReturns, selectedProject, sendPrintSort, isPrintPush,
            pushSelectedProject, isPrintSet, isPrintTakeAway, printTakeAwaySort, orderTypePrintName,/*  wsPrinterStatus, */ prePrintSort,
        } = this.state;
        const allPrinter = this.state.allPrinter?.map((item: printdevice) => {
            return {
                label: item.print_device_name,
                value: item.print_device_id + '、' + item.print_device_name + '、' + item.printer_name
            }
        })

        // const columns: MUIDataTableColumnDef[] = [
        //     {
        //         name: 'rbp_small_ticket_type',
        //         label: i18n.t('print_basic_setting_page_small_ticket_type'),
        //         options: {
        //             sort: false,
        //             customBodyRenderLite: (dataIndex: number) => {
        //                 const type: any = printQueueData?.[dataIndex].print_type;
        //                 const text = _.get(this.printType, type);
        //                 return text ? i18n.t(text) : type;
        //             }
        //         }
        //     },
        //     {
        //         name: 'print_device_name',
        //         label: i18n.t('google_text_printer'),
        //         options: {
        //             sort: false
        //         }
        //     },
        //     {
        //         name: 'table',
        //         label: i18n.t('google_text_table'),
        //         options: {
        //             sort: false,
        //         }
        //     },
        //     {
        //         name: 'customer_name',
        //         label: i18n.t('print_basic_setting_page_client'),
        //         options: {
        //             sort: false,
        //         }
        //     },
        //     {
        //         name: 'order_head_id',
        //         label: i18n.t('print_basic_setting_page_order_time'),
        //         options: {
        //             sort: false,
        //         }
        //     },
        //     {
        //         name: 'order_time',
        //         label: i18n.t('print_basic_setting_page_order_time'),
        //         options: {
        //             sort: false,
        //         }
        //     },
        //     {
        //         name: 'dishes',
        //         label: i18n.t('print_basic_setting_page_dishName'),
        //         options: {
        //             sort: false,
        //             customBodyRenderLite: (dataIndex: number) => {
        //                 const printDishData: any = printQueueData?.[dataIndex].dishes || {};
        //                 let dishName = '';
        //                 Object.keys(printDishData).forEach(turn => {
        //                     (printDishData[turn] || []).forEach((dish: any) => {
        //                         if (dish.item_name1) dishName += dish.item_name1 + '<br/>';
        //                     })
        //                 })
        //                 return <div dangerouslySetInnerHTML={{ __html: dishName }}></div>;
        //             }
        //         }
        //     },
        // ]
        // 选择测试打印机
        const printModeOption = [{
            label: i18n.t('print_native_protocol_page_label'),
            value: 0
        }, {
            label: i18n.t('print_basic_setting_page_qz_printer'),
            value: 1
        }, {
            label: i18n.t('print_basic_setting_page_jk_printer'),
            value: 2
        }, {
            label: i18n.t('print_basic_setting_page__sw_printer'),
            value: 3
        }
            , {
            label: `SW-JK ${i18n.t('google_text_print')}`,
            value: 4
        }
        ]
        // 送厨单打印菜品名方式
        const PrintDishNameTypeOption = [{
            label: `${i18n.t('print_basic_setting_page_dishName')}1+${i18n.t('print_basic_setting_page_dishName')}2`,
            value: 1
        }, {
            label: `${i18n.t('print_basic_setting_page_dishName')}1`,
            value: 2
        }, {
            label: `${i18n.t('print_basic_setting_page_dishName')}2`,
            value: 3
        }]
        // 送厨单打印排序
        const printSortOption = [{
            label: `${i18n.t('print_basic_setting_page_sort_by_category')}`,
            value: 0
        }, {
            label: `${i18n.t('print_basic_setting_page_sort_by_sub_category')}`,
            value: 1
        }]
        // 预结单打印排序
        const advancePrintSortOption = [
            ...printSortOption,
            {
                label: `${i18n.t('print_basic_setting_page_sort_by_order_time')}`,
                value: 2
            }
        ]
        // 送厨单打印字体大小的值
        // const selectFontSizeValueOptions = [{
        //     label: '0',
        //     value: 0
        // }, {
        //     label: '0.5',
        //     value: 0.5
        // }, {
        //     label: '1',
        //     value: 1
        // }, {
        //     label: '2',
        //     value: 2
        // }]
        return (
            <div className='print-page print-page--basic-setting'>
                <Box className='print-setting-card'>
                    <Typography component='h2' className='print-setting-card__title print-setting-card__title--accent'>
                        {i18n.t('print_basic_setting_page_print_method_select')}
                    </Typography>
                    <Box className='print-setting-radio-wrap'>
                        <RadioButtonsGroup
                            radioGroup={printModeOption}
                            value={printMode}
                            handleChange={(value) => {
                                this.setState({ printMode: Number(value) }, () => { void this.patchPrintModeFromState(); });
                            }}
                            row
                        />
                    </Box>
                    {
                        [3, 4].includes(printMode) &&
                        <Grid container spacing={2} className='print-setting-sw-grid' alignItems='flex-end'>
                            <Grid item xs={12} md={5}>
                                <Box className='print-setting-field print-setting-field--sw'>
                                    <Typography
                                        component='label'
                                        className='print-setting-field__label'
                                        htmlFor='print-basic-setting-sw-ip'
                                    >
                                        {i18n.t('print_basic_setting_page_ip_address')}
                                    </Typography>
                                    <CommonInput
                                        id='print-basic-setting-sw-ip'
                                        variant={'outlined'}
                                        fullWidth
                                        hiddenLabel
                                        value={swParam.ip}
                                        onChange={(event: any) => {
                                            this.setState({
                                                swParam: {
                                                    ip: event.target.value,
                                                    port: swParam.port
                                                }
                                            }, () => { this.persistSwParamDebounced(); });
                                        }}
                                        allowClear={true}
                                        required
                                        regularType='ip'
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Box className='print-setting-field print-setting-field--sw'>
                                    <Typography
                                        component='label'
                                        className='print-setting-field__label'
                                        htmlFor='print-basic-setting-sw-port'
                                    >
                                        {i18n.t('print_basic_setting_page_port')}
                                    </Typography>
                                    <CommonInput
                                        id='print-basic-setting-sw-port'
                                        variant={'outlined'}
                                        fullWidth
                                        hiddenLabel
                                        value={swParam.port}
                                        onChange={(event: any) => {
                                            let val = event.target.value;
                                            if (val) {
                                                val = Math.floor(Number(event.target.value));
                                                if (val < 0) val = 0;
                                            }
                                            this.setState({
                                                swParam: {
                                                    ip: swParam.ip,
                                                    port: val
                                                }
                                            }, () => { this.persistSwParamDebounced(); });
                                        }}
                                        required
                                        type={'number'}
                                        regularType='required'
                                    />
                                </Box>
                            </Grid>
                            {/* <Grid item xs={12} md={2}>
                                <Box display='flex' alignItems='center' sx={{ pb: 0.5 }}>
                                    {
                                        wsPrinterStatus === -1 ?
                                            <Chip
                                                style={{
                                                    color: '#af7a18',
                                                    backgroundColor: '#ffa5002e'
                                                }}
                                                label={'Loading'}
                                            />
                                            :
                                            <Chip
                                                onClick={this.goWebSite}
                                                style={STATUS_STYLE_TEXT[wsPrinterStatus as keyof typeof STATUS_STYLE_TEXT].style}
                                                label={STATUS_STYLE_TEXT[wsPrinterStatus as keyof typeof STATUS_STYLE_TEXT].text}
                                            />
                                    }
                                </Box>
                            </Grid> */}
                        </Grid>
                    }
                </Box>
                {/* 一菜一单打印机 */}
                {/* <PrintPageLabel title={i18n.t('print_basic_setting_page_one_order_of_printer')} className='FCS'>
                    <CheckBoxGroup
                        checkBoxGroup={allPrinterOneOrder}
                        handleChange={(value) => {
                            this.setState({ checkList: value });
                        }}
                        value={checkList}
                    />
                </PrintPageLabel> */}
                <Grid container spacing={2} className='print-setting-rules-columns'>
                    <Grid item xs={12} lg={6}>
                        <Box className='print-setting-card'>
                            <Typography component='h2' className='print-setting-card__title'>
                                {i18n.t('print_basic_setting_page_document_rules')}
                            </Typography>
                            <PrintSettingToggleRow
                                title={i18n.t('print_basic_setting_page_independent_ordering_of_singles_printed')}
                                subtitle={i18n.t('print_basic_setting_row_sub_independent')}
                                control={(
                                    <IOSSwitch
                                        checked={isHouseBillOfLadingPrinters}
                                        onChange={() => {
                                            this.setState(
                                                { isHouseBillOfLadingPrinters: !isHouseBillOfLadingPrinters },
                                                () => { void this.patchRule13FromState(); }
                                            );
                                        }}
                                    />
                                )}
                            />
                            <PrintSettingSwitchBlock
                                title={i18n.t('print_basic_setting_page_RWA2_print_take_out_bill')}
                                subtitle={i18n.t('print_basic_setting_row_sub_takeaway_total')}
                                checked={printTakeAwayCheck}
                                onToggle={() => {
                                    this.setState({ printTakeAwayCheck: !printTakeAwayCheck }, () => { this.persistRule30Debounced(); });
                                }}
                            >
                                <CheckBoxGroup
                                    checkBoxGroup={allPrinter}
                                    handleChange={(value) => {
                                        this.setState({ rwa2PrintTakeAwayCheckkList: value }, () => { this.persistRule30Debounced(); });
                                    }}
                                    value={rwa2PrintTakeAwayCheckkList}
                                />
                            </PrintSettingSwitchBlock>
                            {/* CWA2 控制是否 打印外卖总单 */}
                            {/* <PrintPageLabel title={i18n.t('print_basic_setting_page_CWA2_print_take_out_bill')}>
                    <>
                        <Box   >
                            <IOSSwitch
                                checked={cwa2PrintTakeAwayCheck}
                                onChange={async () => {
                                    this.setState({ cwa2PrintTakeAwayCheck: !cwa2PrintTakeAwayCheck });
                                }}
                            />
                        </Box>
                        <CheckBoxGroup
                            disabled={!cwa2PrintTakeAwayCheck}
                            checkBoxGroup={allPrinter}
                            handleChange={(value) => {
                                this.setState({ cwa2PrintTakeAwayCheckkList: value });
                            }}
                            value={cwa2PrintTakeAwayCheckkList}
                        />
                    </>
                </PrintPageLabel> */}
                            <PrintSettingSwitchBlock
                                title={i18n.t('print_basic_setting_page_print_pre_bill')}
                                subtitle={i18n.t('print_basic_setting_row_sub_pre_bill')}
                                checked={isPrintAdvanceStatement}
                                onToggle={() => {
                                    this.setState({ isPrintAdvanceStatement: !isPrintAdvanceStatement }, () => { this.persistRule34Debounced(); });
                                }}
                            >
                                <CheckBoxGroup
                                    checkBoxGroup={allPrinter}
                                    handleChange={(value) => {
                                        this.setState({ isPrintAdvanceStatementPrinters: value }, () => { this.persistRule34Debounced(); });
                                    }}
                                    value={isPrintAdvanceStatementPrinters}
                                />
                            </PrintSettingSwitchBlock>
                            <PrintSettingSwitchBlock
                                title={i18n.t('print_basic_setting_page_rwa_first_order_print_total_order')}
                                subtitle={i18n.t('print_basic_setting_row_sub_first_order')}
                                checked={isPrintFirstOrderSummary}
                                onToggle={() => {
                                    this.setState({ isPrintFirstOrderSummary: !isPrintFirstOrderSummary }, () => { this.persistRule181Debounced(); });
                                }}
                            >
                                <CheckBoxGroup
                                    checkBoxGroup={allPrinter}
                                    handleChange={(value) => {
                                        this.setState({ isPrintFirstOrderSummaryPrinters: value }, () => { this.persistRule181Debounced(); });
                                    }}
                                    value={isPrintFirstOrderSummaryPrinters}
                                />
                            </PrintSettingSwitchBlock>
                            <PrintSettingSwitchBlock
                                title={i18n.t('print_basic_setting_page_turntable_printing')}
                                subtitle={i18n.t('print_basic_setting_row_sub_turntable')}
                                checked={tableTransferPrinting.enable}
                                onToggle={() => {
                                    this.setState({
                                        tableTransferPrinting: {
                                            ...tableTransferPrinting,
                                            enable: !tableTransferPrinting.enable
                                        }
                                    }, () => { this.persistRule166Debounced(); });
                                }}
                            >
                                <CheckBoxGroup
                                    checkBoxGroup={allPrinter}
                                    handleChange={(value) => {
                                        this.setState({
                                            tableTransferPrinting: { ...tableTransferPrinting, printers: value }
                                        }, () => { this.persistRule166Debounced(); });
                                    }}
                                    value={tableTransferPrinting.printers || []}
                                />
                            </PrintSettingSwitchBlock>
                            <PrintSettingToggleRow
                                title={i18n.t('print_basic_setting_page_pre_bill_print_free_dish')}
                                subtitle={i18n.t('print_basic_setting_row_sub_free_dish')}
                                control={(
                                    <IOSSwitch
                                        checked={isPrintFreeDishes}
                                        onChange={() => {
                                            this.setState({ isPrintFreeDishes: !isPrintFreeDishes }, () => { this.persistRule34Debounced(); });
                                        }}
                                    />
                                )}
                            />
                            <PrintSettingToggleRow
                                title={i18n.t('print_basic_setting_page_send_is_print_round')}
                                subtitle={i18n.t('print_basic_setting_row_sub_print_round')}
                                control={(
                                    <IOSSwitch
                                        checked={sendifPrint}
                                        onChange={() => {
                                            this.setState({ sendifPrint: !sendifPrint }, () => { void this.patchRule116FromState(); });
                                        }}
                                    />
                                )}
                            />
                            <PrintSettingRadioBlock
                                title={i18n.t('print_basic_setting_page_print_dish_name_type_option')}
                                subtitle={i18n.t('print_basic_setting_row_sub_dish_name')}
                            >
                                <RadioButtonsGroup
                                    radioGroup={PrintDishNameTypeOption}
                                    value={selectPrintDishNameType}
                                    handleChange={(value) => {
                                        this.setState({ selectPrintDishNameType: Number(value) }, () => { void this.patchRule25FromState(); });
                                    }}
                                    row
                                />
                            </PrintSettingRadioBlock>
                            <PrintSettingRadioBlock
                                title={i18n.t('print_basic_setting_page_send_print_sort')}
                                subtitle={i18n.t('print_basic_setting_row_sub_send_sort')}
                            >
                                <RadioButtonsGroup
                                    radioGroup={printSortOption}
                                    value={sendPrintSort}
                                    handleChange={(value) => {
                                        this.setState({ sendPrintSort: Number(value) }, () => { void this.patchRule126FromState(); });
                                    }}
                                    row
                                />
                            </PrintSettingRadioBlock>
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Box className='print-setting-card'>
                            <PrintSettingSwitchBlock
                                title={i18n.t('print_basic_setting_page_RWA2_print_return')}
                                subtitle={i18n.t('print_basic_setting_row_sub_return')}
                                checked={isPrintReturns}
                                onToggle={() => {
                                    this.setState({ isPrintReturns: !isPrintReturns }, () => { void this.patchRule122FromState(); });
                                }}
                            >
                                <CheckBoxGroup
                                    checkBoxGroup={this.projectList}
                                    handleChange={(value) => {
                                        this.setState({ selectedProject: value }, () => { void this.patchRule122FromState(); });
                                    }}
                                    value={selectedProject}
                                />
                            </PrintSettingSwitchBlock>
                            <PrintSettingSwitchBlock
                                title={i18n.t('print_basic_setting_page_print_push')}
                                subtitle={i18n.t('print_basic_setting_row_sub_push')}
                                checked={isPrintPush}
                                onToggle={() => {
                                    this.setState({ isPrintPush: !isPrintPush }, () => { void this.patchRule144FromState(); });
                                }}
                            >
                                <CheckBoxGroup
                                    checkBoxGroup={this.projectListPush}
                                    handleChange={(value) => {
                                        this.setState({ pushSelectedProject: value }, () => { void this.patchRule144FromState(); });
                                    }}
                                    value={pushSelectedProject}
                                />
                            </PrintSettingSwitchBlock>
                            <PrintSettingRadioBlock
                                title={i18n.t('print_basic_setting_page_pre_bill_print_sort')}
                                subtitle={i18n.t('print_basic_setting_row_sub_pre_sort')}
                            >
                                <RadioButtonsGroup
                                    radioGroup={advancePrintSortOption}
                                    value={prePrintSort}
                                    handleChange={(value) => {
                                        this.setState({ prePrintSort: Number(value) }, () => { void this.patchRule176FromState(); });
                                    }}
                                    row
                                />
                            </PrintSettingRadioBlock>
                            <PrintSettingRadioBlock
                                title={i18n.t('print_basic_setting_page_takeaway_total_order_print_sort')}
                                subtitle={i18n.t('print_basic_setting_row_sub_takeaway_sort')}
                            >
                                <RadioButtonsGroup
                                    radioGroup={advancePrintSortOption}
                                    value={printTakeAwaySort}
                                    handleChange={(value) => {
                                        this.setState({ printTakeAwaySort: Number(value) }, () => { void this.patchRule165FromState(); });
                                    }}
                                    row
                                />
                            </PrintSettingRadioBlock>
                            <PrintSettingToggleRow
                                title={i18n.t('print_basic_setting_page_print_takeaway_ta_suffix')}
                                subtitle={i18n.t('print_basic_setting_row_sub_ta_suffix')}
                                control={(
                                    <IOSSwitch
                                        checked={isPrintTakeAway}
                                        onChange={() => {
                                            this.setState({ isPrintTakeAway: !isPrintTakeAway }, () => { void this.patchRule164FromState(); });
                                        }}
                                    />
                                )}
                            />
                            <PrintSettingToggleRow
                                title={i18n.t('print_basic_setting_page_print_set_suffix')}
                                subtitle={i18n.t('print_basic_setting_row_sub_set_suffix')}
                                control={(
                                    <IOSSwitch
                                        checked={isPrintSet}
                                        onChange={() => {
                                            this.setState({ isPrintSet: !isPrintSet }, () => { void this.patchRule164FromState(); });
                                        }}
                                    />
                                )}
                            />
                            <Box className='print-setting-subsection'>
                                <PrintSettingRowHeading
                                    title={i18n.t('print_basic_setting_page_order_type_print_name')}
                                    subtitle={i18n.t('print_basic_setting_row_sub_order_type_names')}
                                />
                                <Grid container spacing={2} className='print-setting-order-type-grid'>
                                    {
                                        Object.keys(orderTypePrintName).map((key) => {
                                            return (
                                                <Grid item xs={12} sm={6} key={key}>
                                                    <Typography component='div' className='print-setting-order-type-label'>
                                                        {this.getOrderTypeName(Number(key))}
                                                    </Typography>
                                                    <CommonInput
                                                        variant={'outlined'}
                                                        fullWidth
                                                        label=''
                                                        value={_.get(orderTypePrintName, key, '')}
                                                        onChange={(event: any) => {
                                                            const nextNames = _.cloneDeep(this.state.orderTypePrintName);
                                                            _.set(nextNames, key, event.target.value);
                                                            this.setState({ orderTypePrintName: nextNames });
                                                        }}
                                                        onBlur={() => { void this.patchOrderTypeNamesFromState(); }}
                                                        allowClear={true}
                                                        required={true}
                                                        regularType={'required'}
                                                    />
                                                </Grid>
                                            );
                                        })
                                    }
                                </Grid>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                {/* 删除队列弹窗 */}
                <AlertDialog
                    open={alertDialogOpen}
                    variant="delete"
                    title={i18n.t('print_basic_setting_page_delete_queie')}
                    onCancel={() => {
                        this.setState({ alertDialogOpen: false });
                    }}
                    onConfirm={() => {
                        this.setState({ alertDialogOpen: false });
                        this.deletePrintQueueData();
                    }}
                />
            </div>
        )
    }
}

/** 首屏 `init` 完成前占位，结构对齐双列卡片布局（保持简单） */
function PrintSettingPageSkeleton() {
    return (
        <div className="print-page print-page--basic-setting print-page--basic-setting--skeleton">
            <Box className="print-setting-card print-page--basic-setting__skeleton-banner" sx={{ mb: 3, p: 2 }}>
                <Skeleton variant="text" width={320} height={32} sx={{ mb: 2 }} />
                <Skeleton variant="rounded" height={100} sx={{ borderRadius: 1 }} />
            </Box>
            <Grid container spacing={3} className="print-page--basic-setting__skeleton-grid">
                <Grid item xs={12} lg={6}>
                    <Box className="print-setting-card" sx={{ p: 2 }}>
                        <Skeleton variant="text" width={260} height={28} sx={{ mb: 2 }} />
                        {[1, 2, 3, 4, 5, 6].map((k) => (
                            <Skeleton key={`sk-a-${k}`} variant="rounded" height={52} sx={{ mb: 1.5, borderRadius: 1 }} />
                        ))}
                    </Box>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Box className="print-setting-card" sx={{ p: 2 }}>
                        <Skeleton variant="text" width={220} height={28} sx={{ mb: 2 }} />
                        {[1, 2, 3, 4, 5].map((k) => (
                            <Skeleton key={`sk-b-${k}`} variant="rounded" height={52} sx={{ mb: 1.5, borderRadius: 1 }} />
                        ))}
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default PrintSettingPage

// *********************
// State & Props
// *********************

type State = {
    printQueueData: any[];
    selectedPrintQueue: any[];
    checkList: string[],
    selectFontSizeValue: number,
    isHouseBillOfLadingPrinters: boolean;
    selectEmptyLineValue: number;
    selectPrintDishNameType: number;
    deliveryListName1AndName2ShowOnlyOneLine: number;
    rwa2PrintTakeAwayCheckkList: string[];
    cwa2PrintTakeAwayCheckkList: string[];
    isHeartbeatMechanism: boolean;
    heartbeatMechanism: number;
    originHeartbeatMechanism: number;
    isPrintAdvanceStatement: boolean;
    tableTransferPrinting: {
        enable: boolean;
        printers: string[];
    };
    isPrintFreeDishes: boolean;
    isPrintAdvanceStatementPrinters: string[];
    isPrintFirstOrderSummary: boolean;
    isPrintFirstOrderSummaryPrinters: string[];
    printMode: number;
    allPrinter: printdevice[];
    printerType: string;
    printerInterface: string;
    printerPort: string;
    checkedLocationList: string[];
    alertDialogOpen: boolean;
    printTakeAwayCheck: boolean;
    cwa2PrintTakeAwayCheck: boolean;
    swParam: {
        ip: string;
        port?: number;
    },
    sendifPrint: boolean;
    isPrintReturns: boolean;
    selectedProject: string[];
    isPrintPush: boolean;
    pushSelectedProject: string[];
    sendPrintSort: number;
    // 打印外卖TA后缀
    isPrintTakeAway: boolean;
    // 打印套餐SET后缀
    isPrintSet: boolean;
    // 外卖总单打印排序
    printTakeAwaySort: number;
    // 预结单打印排序
    prePrintSort: number;
    // 订单类型打印名称
    orderTypePrintName: {
        0: string;
        1: string;
        2: string;
        3: string;
    };
    // ws打印机状态
    wsPrinterStatus: -1 | 0 | 1;
    pageLoading: boolean;
}

type Props = {}

type printdevice = {
    print_device_id: number;
    print_device_name: string;
    printer_name: string;
}